module.exports = __webpack_public_path__ + "./fonts/make-logo.9719c24313cae3223b7e434ce633d358.svg";